import React, { Component } from 'react'
import style from './style.css'

export default class BoxAccordion extends Component {
    render() {
        return (
            <div
                className={`${style.accordion} ${this.props.show ? style.active : ''}`}
                style={{
                    ...this.props.style,
                    maxHeight: this.props.height
                }}
            >
                {this.props.children}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/v2SPRINTA/atoms/BoxAccordion/index.js